var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabPushActive = function SvgTabPushActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--team)",
    d: "M6.36 20.64a9.5 9.5 0 0 0 11.28 0l1.15-1a9.5 9.5 0 1 0-13.57 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M12 12a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M11.52 12.12a1 1 0 0 1 .96 1.76l-4.15 2.24a1 1 0 0 1-.95-1.76zM5.92 1.5a1 1 0 0 1 .94 1.77 11.07 11.07 0 0 0-4.37 4.2A1 1 0 0 1 .77 6.46a13.07 13.07 0 0 1 5.15-4.95Zm12.16 0a1 1 0 0 0-.94 1.77c1.81.97 3.33 2.42 4.37 4.2a1 1 0 0 0 1.72-1.01 13.07 13.07 0 0 0-5.15-4.95Z"
  }))));
};
export default SvgTabPushActive;